import React from "react";
import { Dropdown } from "react-bootstrap";

// Preserve the form's existing option values and change handlers.
const SetupUserSelect = ({ children, value, name, id, onChange, onBlur, disabled, searchable = false, searchPlaceholder = "Search options..." }) => {
  const [open, setOpen] = React.useState(false);
  const [query, setQuery] = React.useState("");
  const searchInput = React.useRef(null);
  React.useEffect(() => {
    if (open && searchable) searchInput.current?.focus();
  }, [open, searchable]);
  const options = React.Children.toArray(children).filter(
    (child) => React.isValidElement(child) && child.type === "option"
  );
  const selected = options.find((option) => String(option.props.value) === String(value ?? ""));
  const search = query.trim().toLowerCase();
  const filteredOptions = searchable && search
    ? options.filter((option) => option.props.value !== "" && String(option.props.children).toLowerCase().includes(search))
    : options;

  return (
    <Dropdown
      className="setup-user-select"
      show={open}
      onToggle={(nextOpen) => {
        setOpen(nextOpen);
        setQuery("");
      }}
      onBlur={(event) => {
        // Moving focus into the menu is still interacting with this field.
        // Validate on leaving the whole dropdown, after its value is selected.
        if (!event.currentTarget.contains(event.relatedTarget)) {
          onBlur?.({ target: { name, id } });
        }
      }}
    >
      <Dropdown.Toggle
        id={id}
        name={name}
        type="button"
        variant=""
        className={`form-control setup-user-select-trigger ${!value ? "is-placeholder" : ""}`}
        disabled={disabled}
      >
        <span>{selected?.props.children || options[0]?.props.children}</span>
        <svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true">
          <path d="m5 7.5 5 5 5-5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Dropdown.Toggle>
      <Dropdown.Menu className="setup-user-select-menu" role="menu">
        {searchable && (
          <div className="setup-user-select-search">
            <input
              ref={searchInput}
              type="text"
              className="form-control"
              aria-label={searchPlaceholder}
              placeholder={searchPlaceholder}
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "ArrowDown") {
                  event.preventDefault();
                  event.currentTarget.closest(".dropdown-menu")?.querySelector('.dropdown-item:not(.disabled)')?.focus();
                }
              }}
            />
          </div>
        )}
        {filteredOptions.length === 0 && <div className="setup-user-select-empty" role="status">No matches found</div>}
        {filteredOptions.map((option) => (
          <Dropdown.Item
            key={option.props.value}
            role="menuitemradio"
            aria-checked={option === selected}
            active={option === selected}
            disabled={option.props.disabled}
            onClick={() => onChange?.({ target: { name, value: option.props.value } })}
          >
            <span>{option.props.children}</span>
            {option === selected && <span aria-hidden="true">✓</span>}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SetupUserSelect;
